import { LOOKS, Look } from "./look";

/**
 * The Starfall Wyrm's night (M40): deeper and colder than a rare's golden aurora — an ink-blue zenith over a violet
 * horizon, a low lilac key with a rose-gold rim, a cyan fill, deep shadows, a heavy vignette and bloom that catches
 * every scale. A blend target for `SceneRig.blendLooks` through the rig's RareGlow timeline (rareLook.ts): a rare and
 * the Wyrm never stand on the field together, so they share it. Pure numbers, no three.js.
 */
export const WYRM_NIGHT: Look = {
  ...LOOKS.painterly,
  name: "wyrmNight",
  exposure: 0.92,
  // a lilac moon key (it makes the night; a white one read as day), a shade paler than a rare's so the Wyrm's glass keeps colour
  sun: { color: 0xdcc6ff, intensity: 1.65, elevation: 46 },
  fill: { color: 0x5ad8ff, intensity: 1.05 },
  hemi: { sky: 0x6a5cd8, ground: 0x1c1436, intensity: 0.58 },
  sky: 0x3b2f86, fog: 0x1a1648, skyTop: 0x06081f, envSun: 0xffc9e8,
  // over lit diffuse (~1.0): only the emissive glows bloom, so the pale opal body keeps its colour (M40 review)
  bloom: { strength: 0.75, radius: 0.6, threshold: 1.12, knee: 0.18 },
  grade: { contrast: 1.2, saturation: 1.18, vignette: 0.58, shadows: 0x6d62e8, highlights: 0xffe4f6, lift: 0.0 },
};

